var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsuranceProcess1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6159_120461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1494 17.5781H58.501V2.92969C58.501 1.28887 57.2121 0 55.5713 0H8.78906C3.92539 0 0 3.92559 0 8.78906V91.2109C0 96.074 3.92539 100 8.78906 100H67.29C72.1537 100 76.0791 96.074 76.0791 91.2109V20.5078C76.0791 18.867 74.7902 17.5781 73.1494 17.5781Z",
    fill: "#CAE8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0781 20.5078V91.2109C76.0781 96.074 72.1527 100 67.2891 100H37.9922V0H55.5703C57.2111 0 58.5 1.28887 58.5 2.92969V17.5781H73.1484C74.7893 17.5781 76.0781 18.867 76.0781 20.5078Z",
    fill: "#B7E0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0781 23.4375H55.5703C53.951 23.4375 52.6406 22.1271 52.6406 20.5078V0H59.0264C61.3266 0 63.5811 0.932617 65.2062 2.56055L73.5203 10.8775C75.1453 12.5084 76.0781 14.757 76.0781 17.0516V23.4375Z",
    fill: "#CAE8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4065 31.4111C94.1257 28.0713 88.2663 28.0713 84.9847 31.4111L81.9964 34.4582L79.887 36.5088C78.7147 37.6221 78.7147 39.4971 79.887 40.6104L84.047 44.7707L88.2075 48.9307C89.2618 50.1025 91.2546 50.1025 92.3089 48.9307L94.4183 46.8801L97.4065 43.833C100.863 40.5516 100.863 34.6922 97.4065 31.4111Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0052 64.8028L57.9699 58.7674C57.8533 58.6504 57.7359 58.6504 57.6187 58.7674L57.4435 58.8848C57.0916 59.2364 56.857 59.6465 56.7396 60.0567L52.5797 72.5372C52.1691 73.7088 52.5211 74.8221 53.2828 75.5254V75.5836C54.1031 76.3454 55.2162 76.6383 56.2711 76.2284L68.7515 72.068C69.1621 71.9506 69.5718 71.7165 69.9232 71.3649L70.0406 71.2475C70.158 71.1305 70.158 71.0133 70.0406 70.896C68.1072 68.9044 65.9978 66.7948 64.0052 64.8028Z",
    fill: "#FEDBAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5728 35.1562H14.65C10.7833 35.1562 10.7833 29.2969 14.65 29.2969H55.5728C59.4396 29.2969 59.4396 35.1562 55.5728 35.1562Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.854 46.875H14.65C10.7833 46.875 10.7833 41.0156 14.65 41.0156H43.854C47.7208 41.0156 47.7208 46.875 43.854 46.875Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.854 58.5938H14.65C10.7833 58.5938 10.7833 52.7344 14.65 52.7344H43.854C47.7208 52.7344 47.7208 58.5938 43.854 58.5938Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.854 70.3125H14.65C10.7833 70.3125 10.7833 64.4531 14.65 64.4531H43.854C47.7208 64.4531 47.7208 70.3125 43.854 70.3125Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5718 88.2812H37.9937C34.1271 88.2812 34.1271 82.4219 37.9937 82.4219H55.5718C59.4386 82.4219 59.4386 88.2812 55.5718 88.2812Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0115 64.8047C66.0043 66.7967 68.1135 68.9063 70.0469 70.8982C70.1643 71.0156 70.1643 71.1328 70.0469 71.2498L69.9295 71.3672C69.5783 71.7188 69.1686 71.9529 68.7578 72.0703L56.2773 76.2307C55.2223 76.6404 54.1094 76.3477 53.2891 75.5859V75.5273L64.0115 64.8047Z",
    fill: "#FEC478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4064 43.8281L94.418 46.8752L92.3086 48.9258C91.2543 50.0977 89.2615 50.0977 88.2072 48.9258L84.0469 44.7658L97.4064 31.4062C100.863 34.6875 100.863 40.5469 97.4064 43.8281Z",
    fill: "#136EF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4184 46.8711L92.309 48.9217C80.7076 60.4648 84.5742 56.5975 74.1443 67.0273C74.1443 67.1443 69.9844 71.3045 69.9258 71.3633C69.5746 71.7148 69.1648 71.949 68.7541 72.0664L56.7422 60.0547C56.8596 59.6445 57.0941 59.2344 57.4461 58.8828C57.5047 58.8242 61.6646 54.6639 61.782 54.6639C69.3988 47.0467 65.6486 50.8555 79.8873 36.5L81.9379 34.3906L94.4184 46.8711Z",
    fill: "#FD003A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4223 46.875L92.3129 48.9256C80.7115 60.4688 84.5781 56.6014 74.1482 67.0313C74.1482 67.1482 69.9883 71.3084 69.9297 71.3672C69.5785 71.7188 69.1687 71.9529 68.758 72.0703L62.7812 66.0936L88.2117 40.6641L94.4223 46.875Z",
    fill: "#E50027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 70.3125H37.9922V64.4531H43.8516C47.7184 64.4531 47.7184 70.3125 43.8516 70.3125Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 58.5938H37.9922V52.7344H43.8516C47.7184 52.7344 47.7184 58.5938 43.8516 58.5938Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8516 46.875H37.9922V41.0156H43.8516C47.7184 41.0156 47.7184 46.875 43.8516 46.875Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5703 88.2812H37.9922V82.4219H55.5703C59.4371 82.4219 59.4371 88.2812 55.5703 88.2812Z",
    fill: "#1689FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5703 35.1562H37.9922V29.2969H55.5703C59.4371 29.2969 59.4371 35.1562 55.5703 35.1562Z",
    fill: "#1689FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6159_120461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceProcess1);
export default __webpack_public_path__ + "static/media/insurance_process1.6a6c2d93525096847bd274731aa0b9e4.svg";
export { ForwardRef as ReactComponent };